import Vue from 'vue'
import Router from 'vue-router'

/* Implemented as a factory in order to prevent the router from
 * auto loading
 */
function router_factory() {

    Vue.use(Router)

    return new Router({
        routes: [
            {
                path: '/',
                name: 'push',
                component: () => import('./views/RedirectHandler.vue'),
                meta: {
                    title: "Evenly SupplierCheck"
                }
            },
            // Supplier Check
            {
                path: '/dashboard/',
                name: 'home',
                component: () => import('./views/suppliercheck/Dashboard.vue'),
                meta: {
                    title: "Dashboard"
                }
            },
            {
                path: '/alert-list/',
                name: 'alertlist',
                component: () => import('./views/suppliercheck/AlertList.vue'),
                meta: {
                    title: "Alert List"
                }
            },
            {
                path: '/profile/:id',
                name: 'profile',
                component: () => import('./views/suppliercheck/Profile.vue'),
                meta: {
                    title: "Profile"
                }
            },
            {
                path: '/org-selector/',
                name: 'orgselector',
                component: () => import('./views/OrgSelector.vue'),
                meta: {
                    title: "Choose Organisation"
                }
            },
            {
                path: '/supplier-list/:trendStatus?',
                name: 'supplierlist',
                component: () => import('./views/SupplierList.vue'),
                meta: {
                    title: "Your Suppliers"
                }
            },
           
            {
                path: '/settings/',
                name: 'settings',
                component: () => import('./views/Settings.vue'),
                meta: {
                    title: "Account Settings"
                }
            },
            {
                path: '/alert-settings',
                name: 'alertSettings',
                component: () => import('./views/AlertSettings.vue'),
                meta: {
                    title: "Alert Settings"
                }
            },
            {
                path: '/contact/',
                name: 'contact',
                component: () => import('./views/Contact.vue'),
                meta: {
                    title: "Contact Us (coming soon?)"
                }
            },
            {
                path: '/customer-message/',
                name: 'customermessagethanks',
                component: () => import('./views/CustomerMessageThanks.vue'),
                meta: {
                    title: "Send Customers a Reminder or Thanks"
                }
            },
            {
                path: '/customer-message/:filter/',
                name: 'customermessagethanksfilter',
                component: () => import('./views/CustomerMessageThanks.vue'),
                meta: {
                    title: "Send Customers a Reminder or Thanks"
                }
            },
            {
                path: '/customer-message/:filter/:id',
                name: 'customermessagethanksid',
                component: () => import('./views/CustomerMessageThanks.vue'),
                meta: {
                    title: "Send Customers a Reminder or Thanks"
                }
            },
            {
                path: '/supplier/add',
                name: 'supplier_add',
                component: () => import('./views/AddSupplier.vue'),
                meta: {
                    title: "Add Supplier in your list"
                }
            },
        ],
        mode: "history",
        base: "/sc/",
        scrollBehavior() {
            return { x: 0, y: 0 }
        }
    })
}

export default router_factory
